/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_Core_Dtos_PagedResultDto_1 } from '../models/Routemize_Core_Dtos_PagedResultDto_1';
import type { Routemize_DTOs_ContactDTO } from '../models/Routemize_DTOs_ContactDTO';
import type { Routemize_DTOs_ContactDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_ } from '../models/Routemize_DTOs_ContactDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_';
import type { Routemize_DTOs_CreateContactDTO } from '../models/Routemize_DTOs_CreateContactDTO';
import type { Routemize_DTOs_UpdateContactDTO } from '../models/Routemize_DTOs_UpdateContactDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ContactDTO OK
     * @throws ApiError
     */
    public static postApiAppContactCreate(
        requestBody?: Routemize_DTOs_CreateContactDTO,
    ): CancelablePromise<Routemize_DTOs_ContactDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/contact/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppContactDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/contact/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_ContactDTO OK
     * @throws ApiError
     */
    public static getApiAppContactGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_ContactDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/contact/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param searchText
     * @param status
     * @param tagIds
     * @param source
     * @param isFavorite
     * @param lastContactDateFrom
     * @param lastContactDateTo
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns Routemize_Core_Dtos_PagedResultDto_1<Routemize_DTOs_ContactDTO_Routemize_Application_Contracts_Version_1_0_0_0_Culture_neutral_PublicKeyToken_null_> OK
     * @throws ApiError
     */
    public static getApiAppContactGetList(
        searchText?: string,
        status?: string,
        tagIds?: Array<string>,
        source?: string,
        isFavorite?: boolean,
        lastContactDateFrom?: string,
        lastContactDateTo?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<Routemize_Core_Dtos_PagedResultDto_1> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/contact/getList',
            query: {
                'SearchText': searchText,
                'Status': status,
                'TagIds': tagIds,
                'Source': source,
                'IsFavorite': isFavorite,
                'LastContactDateFrom': lastContactDateFrom,
                'LastContactDateTo': lastContactDateTo,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_ContactDTO OK
     * @throws ApiError
     */
    public static putApiAppContactUpdate(
        requestBody?: Routemize_DTOs_UpdateContactDTO,
    ): CancelablePromise<Routemize_DTOs_ContactDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/contact/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_ContactDTO OK
     * @throws ApiError
     */
    public static postApiAppContactToggleFavorite(
        id: string,
    ): CancelablePromise<Routemize_DTOs_ContactDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/contact/{id}/toggleFavorite',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param ids
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppContactDeleteMultiple(
        ids?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/contact/deleteMultiple',
            query: {
                'ids': ids,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppContactArchiveMultiple(
        requestBody?: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/contact/archiveMultiple',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
